import { LogLevelEnum } from 'shared/core/data-access/log';
import { ThemeEnum } from 'shared/design-system/data-access/theme';
import { Environment } from './environment.model';

export const environment: Environment = {
    appName: 'fines-portal',
    environmentName: 'fixture',
    assetImagePath: '',
    assetConfigPath: '',
    defaultTheme: ThemeEnum.LIGHT,
    mapKey: '',
    version: '',
    apiBasePath: '',
    logLevel: LogLevelEnum.ALL,
    storageKey: 'fines-portal',
    authRegistrationId: '',
    currency: '',
    speedUnit: '',
};
